import * as React from 'react';
import { icons } from '../../style/icons';
import { H1 } from '../../style/typography';
import {
  ScheduleHorizontalRedLines,
  ScheduleHorizontalRedLinesXl,
  MicImage,
  ScheduleHeaderContainer,
  ScheduleHeader,
  Star,
} from './ScheduleHeaderSection.style';

const ScheduleHeaderSection = ({ title1, title2, isInPerson }) => {
  return (
    <>
      <ScheduleHorizontalRedLines
        src={icons.HORIZONTAL_RED_LINES.image}
        altText={icons.HORIZONTAL_RED_LINES.altText}
      />
      <ScheduleHorizontalRedLinesXl
        src={icons.HORIZONTAL_RED_LINES_XL.image}
        altText={icons.HORIZONTAL_RED_LINES_XL.altText}
      />
      <MicImage
        src={
          isInPerson
            ? icons.MIC4_TANMINT.image
            : icons.MIC4_PERIWINKLEBLUE.image
        }
        altText={
          isInPerson
            ? icons.MIC4_TANMINT.altText
            : icons.MIC4_PERIWINKLEBLUE.alttext
        }
      />
      <Star
        src={isInPerson ? icons.PURPLE_STAR.image : icons.YELLOW_STAR.image}
        altText={
          isInPerson ? icons.PURPLE_STAR.altText : icons.YELLOW_STAR.altText
        }
      />
      <ScheduleHeaderContainer>
        <ScheduleHeader isInPerson={isInPerson}>{title1}</ScheduleHeader>
        <ScheduleHeader isInPerson={isInPerson}>{title2}</ScheduleHeader>
      </ScheduleHeaderContainer>
    </>
  );
};

export default ScheduleHeaderSection;
